/** Set to false if backend rejects unknown field incoterm_location_id before its follow-up ticket ships. */
export const SEND_INCOTERM_LOCATION_ID = true;
export const INCOTERM_LOCATION_SEARCH_MIN_CHARS = 2;
export const INCOTERM_LOCATION_SEARCH_DEBOUNCE_MS = 300;
export const INCOTERM_LOCATION_PAGE_SIZE = 20;
